<template>
    <div id="Alert">
        <div class="alert-container">
            <div class="text">
                {{ text }}
            </div>
            <div class="buttons">
                <Button
                    class="alert-btn ghost"
                    @btnClicked="() => $emit('cancel')"
                    :size="'large'"
                    :border="'1px solid rgba(15, 23, 42, 0.14)'"
                    :paddingY="'12px'"
                    :borderRadius="'var(--sps-radius-md)'"
                    :bgColor="'transparent'"
                >
                    <span class="alert-btn-label ghost">{{ $t("message.no") }}</span>
                </Button>
                <Button
                    class="alert-btn primary"
                    @btnClicked="() => $emit('ok')"
                    :size="'large'"
                    :paddingY="'12px'"
                    :borderRadius="'var(--sps-radius-md)'"
                    :bgColor="'var(--button-color)'"
                >
                    <span class="alert-btn-label">{{ $t("message.yes") }}</span>
                </Button>
            </div>
        </div>
    </div>
</template>
<script>
import Button from "../../common/Button.vue";
import { mapState, mapActions, mapMutations } from "vuex";
import { sendCommandToParentWindow } from "../../utils/parentWindowConnection";
import _ from "lodash";

export default {
    name: "Alert",
    props: ["text"],
    components: { Button },
    data() {
        return {};
    },

    methods: {},
    computed: {
        ...mapState({
            visitingPage: (state) => state.app.visitingPage,
            settings: (state) => state.setting.settings,
        }),
    },
    mounted() {
        const color = _.get(this.settings, "chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst");
        if (color) {
            sendCommandToParentWindow("visible-window-bg", { color });
        }
    },
    beforeDestroy() {
        const color = _.get(this.settings, "chatCustomizationSettings.versionV2Theme.colors.backgroundColorFirst");
        sendCommandToParentWindow("visible-window-bg", { color });
    },
};
</script>
<style scoped lang="scss">
#Alert {
    background-color: var(--background-color-first);
    position: fixed;
    inset: 0;
    width: 100%;
    height: calc(var(--app-vh, 100vh));
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px 20px;
    box-sizing: border-box;

    .alert-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 22px;
        width: 100%;
        max-width: 340px;
    }

    .text {
        font-weight: 600;
        font-size: 17px;
        line-height: 1.45;
        text-align: center;
        color: var(--primary-text);
        margin: 0;
        padding: 0 4px;
    }

    .buttons {
        display: flex;
        align-items: stretch;
        gap: 10px;
        width: 100%;

        ::v-deep #button {
            flex: 1;
        }

        ::v-deep .container {
            min-height: 46px;
            transition: transform 140ms ease, box-shadow 140ms ease, background-color 140ms ease;
        }

        ::v-deep .alert-btn.primary .container {
            box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1);

            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 6px 16px rgba(16, 24, 40, 0.16);
            }
        }

        ::v-deep .alert-btn.ghost .container:hover {
            background-color: rgba(15, 23, 42, 0.04) !important;
        }
    }

    .alert-btn-label {
        font-size: 15px;
        font-weight: 600;
        color: var(--button-text-color, #fff);

        &.ghost {
            color: var(--primary-text);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/V2/Alert.vue